import { segment } from '@actions/analytics';
import LinkTag from '@base/Link/Link';
import { DOW2_AAD_STARTED } from '@constants/segment';
import styled from '@emotion/styled';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { getImage } from '@utils/imageHelper';

const AiDoubtsPill = ({
  goalUID,
  goalSlug
}: {
  goalUID: string;
  goalSlug: string;
}) => {
  const routeGoalSegmentData = useGoalEventProps({ goalUID });

  const handleClick = () => {
    segment.track(DOW2_AAD_STARTED, {
      last_primary_source_section: 'Menu Tab',
      click_a_picture_clicked: 'No',
      feature_version: 2,
      doubt_source: 'Ask AI Floater',
      doubt_type: 'Doubts AI',
      ...routeGoalSegmentData
    });
  };
  return (
    <LinkButton
      onClick={handleClick}
      href="/goal/[goalSlug]/[goalUID]/doubts-and-solutions/unacademy-ai"
      as={`/goal/${goalSlug}/${goalUID}/doubts-and-solutions/unacademy-ai`}
    >
      <Icon src={getImage('unacademy-ai/touchpoint-logo.svg')} alt="Icon" />
      <Text>Ai Doubts</Text>
    </LinkButton>
  );
};

export default AiDoubtsPill;

const LinkButton = styled(LinkTag)`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  width: max-content;
  padding: 8px 10px;
  background: #1e2429;
  color: white;
  border: 2px solid black;
  border-radius: 36px;
  cursor: pointer;
  outline: none;

  &::before {
    content: '';
    position: absolute;
    inset: -1px;
    border-radius: 50px;
    padding: 2px;
    background: linear-gradient(
      258.74deg,
      #fd3f65 17.72%,
      #594aff 55.17%,
      #3f9bfd 90.31%
    );
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    mask-composite: xor;
    pointer-events: none;
  }
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const Text = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -3%;
  text-align: center;
`;
